import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  subtitle = 'From bootcamp and group fitness coaches running outdoor, studio and park classes.',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-ice';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-209" data-mp="3228za26tkd2j">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-210" data-mp="2x1bi9sxjpp2m">
        <div className="text-center" data-id="element-211" data-mp="2s28h4jkos2zx">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-212" data-mp="2s39syq9j0tip">
            Coach to coach
          </p>
          <h2 className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-213" data-mp="qac415ivel31">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-214" data-mp="h5or9fhq4e9j">{subtitle}</p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-215" data-mp="m5b5ns9ag0jx">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-ice-dark bg-white p-5 shadow-card" data-id="element-216" data-mp="7928cw8yjxa5" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-217" data-mp="c7mwvyeuksir">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-ice-dark" data-id="element-218" data-mp="zxhc2mmn2t66" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-[11px] font-bold text-white" data-id="element-219" data-mp="v3wmniz437il">
                    {item.author.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase() || 'BR'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-220" data-mp="1xgxv8z0chnh5">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-221" data-mp="1sjphdam8c5lp" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-222" data-mp="1jh6e4pej7qyx">{item.quote}</blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-223" data-mp="1ejejvoqezsrk">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-224" data-mp="19sermws8pyve">{item.author}</span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}